import logo from './logo.svg';
import './App.css';
import React, { createContext, useState, useEffect, Component } from "react";
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider, Helmet } from "react-helmet-async";
import ScrollToTop from "./ScrollToTop.jsx";

//Iport Components
import {Home} from './components/home/home';
import { DevelopComponent } from './components/developComponent/developComponent.js'
import { GoogleAdsCompt } from './components/googleADS/googleAdsCompt.js';
import { ContactCompt } from './components/contactCompt/contactCompt.js';
import {  DataRemainingCompt } from './components/dataRemainingCompt/dataRemainingCompt.js'
import { SoportEmpresasCompt } from './components/soporteEmpresas/soportEmpresasCompt.js'

//Import Assets
//Iconos Develop
import IconDevHtml from './assets/iconosDevelop/Icon-Dev-html.svg';
import IconDevCss from './assets/iconosDevelop/Icon-Dev-Css.svg';
import IconDevJs from './assets/iconosDevelop/Icon-Dev-Js.svg';
import IconDevReact from './assets/iconosDevelop/Icon-Dev-React.svg';
import IconDevChrome from './assets/iconosDevelop/Icon-Dev-Chrome.svg';
import IconDevSafari from './assets/iconosDevelop/Icon-Dev-Safari.svg';
import IconDevChtGPT from './assets/iconosDevelop/Icon-Dev-ChatGPT.svg';
import IconDevgemini from './assets/iconosDevelop/Icon-Dev-Gemini.svg';
import IconDesktop from './assets/iconMobileDesing/Icon-Desktop.svg';
import IconTablets from './assets/iconMobileDesing/Icon-Tablets.svg';
import IconMobile from './assets/iconMobileDesing/Icon-Mobile.svg';
import IconEnfoqueDinamico from "./assets/iconEnfoque/Icon-Enfoque-Dinamico.svg"
import IconEnfoqueFuncional from "./assets/iconEnfoque/Icon-Enfoque-Funcional.svg"
import IconEnfoqueProductivo from "./assets/iconEnfoque/Icon-Enfoque-Productivo.svg"
import IconEnfoqueHand from "./assets/iconEnfoque/Icon-Enfoque-hand.svg"
import IconAnalytics from './assets/IconWebGoogle/IconWebGoogle-Analytics.svg'
import IconADS from './assets/IconWebGoogle/IconWebGoogle-Ads.svg'
import IconMaps from './assets/IconWebGoogle/IconWebGoogle-Maps.svg'
import IconActualizacion from './assets/iconRedineno/Icon-Act.svg'
import IconRediseno from './assets/iconRedineno/Icon-ReDiseno.svg'
import IconSeoIA from './assets/iconRedineno/Icon-SeoIA.svg'
import IconWordPress from './assets/iconRedineno/Icon-Wordpress.svg'
import IconShopify from './assets/iconRedineno/Icon-Shopify.svg'
import IconWix from './assets/iconRedineno/Icon-Wix.svg'
import IconJoomla from './assets/iconRedineno/Icon-Joomla.svg'
import IconSoporteLicencias from './assets/iconSoporte/IconSoporte-33.svg'
import IconSoporHosting from './assets/iconSoporte/IconSoporte-34.svg'
import IconSoporEmailMark from './assets/iconSoporte/IconSoporte-35.svg'
import IconSoporFormatting from './assets/iconSoporte/IconSoporte-36.svg'
import IconArrowNext from './assets/iconSoporte/arrowNext2-37.svg'
import IconDevWordPress from './assets/iconosDevelop/Icon-Dev-WordPress.svg'
import IconDevShoify from './assets/iconosDevelop/Icon-Dev-Shopify.svg'
import IconDevWix from './assets/iconosDevelop/Icon-Dev-Wix.svg'
import IconDevJoomla from './assets/iconosDevelop/Icon-Dev-Joomla.svg'
import IconMDIos from './assets/iconMobileDesing/Icon-MD-IOS.svg'
import IconMDGoogle from './assets/iconMobileDesing/Icon-MD-Google.svg'
import IconMDMicrosoft from './assets/iconMobileDesing/Icon-MD-Microsoft.svg'
import IconMDAndroid from './assets/iconMobileDesing/Icon-MD-Android.svg'
import photoDinamico from './assets/popUpAssets/photoDinamico.jpg'
import photoFuncional from './assets/popUpAssets/photoFuncional.jpg'
import photoComercial from './assets/popUpAssets/photoComercial.jpg'
import logoWebMediaPopUp from './assets/homeAssets/logoWebMedia-popUp.svg'
import IconGoogleIsotipoAnalitycs from './assets/IconWebGoogle/IconosGoogle-Isotipo/Icon-Analitycs.svg'
import IconGoogleIsotipoAds from './assets/IconWebGoogle/IconosGoogle-Isotipo/Icon-Ads.svg'
import IconGoogleIsotipoMaps from './assets/IconWebGoogle/IconosGoogle-Isotipo/Icon-Maps.svg'
import IconGoogleIsotipoPhotos from './assets/IconWebGoogle/IconosGoogle-Isotipo/Icon-Photos.svg'


const textPopUp = [
  'Desarrollamos sitios web dinámicos con un estilo moderno, iconos personalizados, información desplegable, portadas animadas, enlaces y links de compartición personalizados para que su sitio tenga la calidad que usted necesita.',
  'Implementamos herramientas funcionales que mejoran la experiencia del usuario. Insertamos mapas de ubicación, formularios de contacto, enlaces multiples a whatsapp, botones de pago y mucho más. ',
  'Desarrollamos su web haciendo énfasis en el contenido SEO para obtener las mejores oportunidades de posicionamiento y escala en los ranking de búsqueda para generar meyores oportunidades de venta.'

]

const titlePopUp = [
  'Enfoque Dinámico',
  'Enfoque Funcional',
  'Enfoque Comercial'
]

    
const iconsBrandsDevelop = [ 

    IconDevHtml, 
    IconDevCss, 
    IconDevJs, 
    IconDevReact, 
    IconDevChrome, 
    IconDevSafari, 
    IconDevChtGPT, 
    IconDevgemini, 
    IconMDIos,
    IconMDGoogle,
    IconMDMicrosoft,
    IconMDAndroid,
    IconGoogleIsotipoAnalitycs,
    IconGoogleIsotipoAds,
    IconGoogleIsotipoMaps,
    IconGoogleIsotipoPhotos
    

];



export const AppContext = createContext();

export  default function App() {


    //State popUPEnfoque 
    const [popUpOpen, setpopUpOpen] = useState(false);


    //State Valor PopUp
    const [valorPopUp, setValorPopUp] = useState(null);

    
    //State Barra Down
    const [visible, setVisible] = useState(false);


    //State Menu Mobile Slide
    const [panelIsOpen, setPanelIsOpen] = useState(false);

   //State Slide Panel Menu Dv
    const [openMenuSlideDv,  setOpenMenuSlideDv ] = useState(false)

    //State Screen Develop
    const [valorScreenDv, setValorScreenDv] = useState(0)



    //Effect Barra Down Scroll
    useEffect(() => {
        const handleScroll = () => {
        if (window.scrollY > 300) {
            setVisible(true);
        } else {
            setVisible(false);
        }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);

    }, []);



   //  Reset al montar el componente
    useEffect(() => {
      setPanelIsOpen(false);
      setOpenMenuSlideDv(false);

    }, []); // [] asegura que solo se ejecute una vez al montar



  return (

    <AppContext.Provider value={{
      
      //State Barra Menu Down 
      visible,
      setVisible,
      //Menu Mobile Slide
      panelIsOpen,
      setPanelIsOpen,
      //Panel Menu Slide Dv
      openMenuSlideDv,
      setOpenMenuSlideDv,
      valorScreenDv,
      setValorScreenDv,
      //Iconos Develop
      IconDevHtml,
      IconDevCss,
      IconDevJs,
      IconDevReact,
      IconDevChrome,
      IconDevSafari,
      IconDevChtGPT,
      IconDevgemini,
      IconDevWordPress,
      IconDevShoify,
      IconDevWix,
      IconDevJoomla,
      iconsBrandsDevelop,
      //Iconos Mobile Desing
      IconDesktop,
      IconTablets,
      IconMobile,
      IconMDIos,
      IconMDGoogle,
      IconMDMicrosoft,
      IconMDAndroid,
       //Iconos Enfoque
      IconEnfoqueDinamico,
      IconEnfoqueFuncional,
      IconEnfoqueProductivo,
      IconEnfoqueHand,
      //Iconos Web Google
      IconAnalytics,
      IconADS,
      IconMaps,
      //Iconos Web Rediseno
      IconActualizacion,
      IconRediseno,
      IconSeoIA,
      IconWordPress,
      IconShopify,
      IconWix,
      IconJoomla,
      //Iconos Soporte
      IconSoporteLicencias,
      IconSoporHosting,
      IconSoporEmailMark,
      IconSoporFormatting,
      IconArrowNext , 
      // State popUp Enfoque
      popUpOpen,
      setpopUpOpen,
      // PopUpAssets
      photoDinamico,
      photoFuncional,
      photoComercial,
      textPopUp,
      titlePopUp,
      logoWebMediaPopUp,
      valorPopUp, 
      setValorPopUp

    }}>

      <HelmetProvider>
          <div className="App">
            <BrowserRouter>
              <ScrollToTop />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/desarrollo-web" element={<DevelopComponent />} />
                    <Route path="/google-ads" element={<GoogleAdsCompt />} />
                    <Route path="/email-marketing" element={<DataRemainingCompt />} />
                    <Route path="/soporte-empresas" element={<SoportEmpresasCompt />} />
                    <Route path="/contacto" element={<ContactCompt />} />
                </Routes>
              </BrowserRouter>
          </div>
        </HelmetProvider> 
    </AppContext.Provider>

  )
}


